import { render, staticRenderFns } from "./data-tree.vue?vue&type=template&id=067ab20c&scoped=true"
import script from "./data-tree.vue?vue&type=script&lang=ts"
export * from "./data-tree.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067ab20c",
  null
  
)

export default component.exports